import { Link } from "react-router-dom";
import { Logo } from "@/components/Header";
import { useLang } from "@/lib/i18n";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const Footer = () => {
  const { t, lang } = useLang();
  const links = [["/terms", t("terms")], ["/privacy", t("privacy")], ["/refund-policy", t("refund")], ["/guidelines", t("guidelines")], ["/safety", t("safety_page")], ["/support", t("nav_support")], ["/about", lang === "hi" ? "हमारे बारे में" : "About Us"], ["/faq", lang === "hi" ? "सामान्य प्रश्न" : "FAQ"]];
  return (
    <footer className="mt-auto bg-[#0F172A] text-slate-300">
      <div className="container-x py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-3">
          <div className="[&_span]:text-white"><Logo /></div>
          <p className="text-sm text-slate-400 max-w-xs">{t("footer_tag")}</p>
          <p className="text-xs text-slate-500">Strictly 18+ · Platonic companionship only · Not an escort service.</p>
        </div>
        <div className="grid grid-cols-2 gap-3 text-sm">
          {links.map(([to, l]) => <Link key={to} to={to} className="hover:text-white transition-colors" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>)}
        </div>
        <div className="text-sm space-y-2">
          <p className="eyebrow !text-emerald-400">Support</p>
          <p><Link to="/support" className="underline hover:text-white" data-testid="footer-support-contact">{lang === "hi" ? "सहायता पेज से संपर्क करें" : "Contact us via the Support page"}</Link></p>
          <p><a href="mailto:support@rentmydate.in" className="hover:text-white" data-testid="footer-support-email">support@rentmydate.in</a></p>
          <p><a href="tel:+917479913855" className="hover:text-white" data-testid="footer-support-phone">+91 74799 13855</a></p>
          <WhatsAppButton label={lang === "hi" ? "WhatsApp पर चैट करें" : "Chat on WhatsApp"} testId="footer-whatsapp-btn" className="!px-4 !py-2" />
          <p data-testid="footer-address">RentMyDate ({lang === "hi" ? "स्वामित्व फ़र्म" : "Proprietorship"}) · {lang === "hi" ? "दुमका, झारखंड 814101, भारत" : "Dumka, Jharkhand 814101, India"} · 9:00–21:00 IST</p>
          <p className="text-slate-500" data-testid="footer-grievance">{lang === "hi" ? "शिकायत अधिकारी: जोगेश" : "Grievance Officer: Jogesh"}</p>
          <p className="text-slate-500">Emergency: 112 · Women Helpline: 1091</p>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© 2026 RentMyDate · {lang === "hi" ? "केवल नकद भुगतान · 18+ वयस्कों के लिए प्लेटोनिक साथ" : "Cash payments only · Platonic companionship for adults 18+"}</div>
    </footer>
  );
};
